import z from "zod";

import { BusinessSchema } from "./business";
import { ShiftSchemaResponse } from "./shift";
import { nullableToOptional } from "./utils";

export const ReviewSchema = z.object({
  id: z.number(),
  shift: ShiftSchemaResponse.optional(),
  business: BusinessSchema.optional(),
  worker: z.object({
    full_name: z.string().nullable(),
    avatar_url: z.string().nullable(),
    email: z.string(),
  }).optional(),
  rating: nullableToOptional(z.record(z.string(), z.number())),
  shift_id: z.number().optional(),
  worker_id: z.string().optional(),
  business_id: z.number().optional(),
  review_text: z.string().optional(),
  review_type: z.enum(["EMPLOYER", "WORKER"]).optional(),
});

export type Review = z.infer<typeof ReviewSchema>;

export const AddBusinessReviewSchema = z.object({
  rating: z.record(z.string(), z.number()).optional(),
  review_text: z.string().optional(),
  business_id: z.number().optional(),
});

export type AddBusinessReviewPayload = z.infer<typeof AddBusinessReviewSchema>;

export const AddBusinessReviewResponseSchema = z.object({
  message: z.string().nullable(),
  success: z.boolean(),
});

export type AddBusinessReviewResponse = z.infer<
  typeof AddBusinessReviewResponseSchema
>;

// Worker review reuses the same payload/response shape
export const AddWorkerReviewSchema = z.object({
  rating: z.record(z.string(), z.number()).optional(),
  review_text: z.string().optional(),
  worker_id: z.string().optional(),
});
export type AddWorkerReviewPayload = AddBusinessReviewPayload;
export const AddWorkerReviewResponseSchema = AddBusinessReviewResponseSchema;
export type AddWorkerReviewResponse = AddBusinessReviewResponse;

export const ReviewListSchemaResponse = z.object({
  message: z.string().nullable(),
  success: z.boolean().default(false),
  reviews: z.array(ReviewSchema),
  total: z.number().optional(),
});

export type ReviewListResponse = z.infer<typeof ReviewListSchemaResponse>;

export const BusinessReviewListSchemaResponse = ReviewListSchemaResponse;
export type BusinessReviewListResponse = ReviewListResponse;
